import React, { useEffect, useMemo, useState } from 'react';
import Search from 'antd/es/input/Search';
import { App, Button, Divider, Modal, Popconfirm, Spin, Tooltip, Upload, UploadProps } from 'antd';
import {
  FullscreenOutlined,
  DownloadOutlined,
  UploadOutlined,
  ReloadOutlined,
  DeleteOutlined,
  PlusOutlined,
} from '@ant-design/icons';
import { VisualizationXPathes } from '../VisualizationXPathes/VisualizationXPathes';
import {
  getAllKeys,
  getMappedData,
  getAddedMaxData,
  getNormalData,
  getSavedMaxData,
  loop,
  loopInfoData,
  loopSearchLabel,
  getParentDataOptions,
  getDataForCheckXPath,
  getVerificationXPathData,
  getCheckedKeysMaxData,
  getUniqueData,
  // getPreNormalData,
} from '../../../../helpers/helpers';
import { useAppDispatch, useAppSelector } from '../../../../../../core/redux';
import { tablesSlice } from '../../../../TablesSlice';
import { notificationMessages, showNotification } from '../../../../../usersPage/helpers/helpers';
import { projectsApiService } from '../../../../../../api/projects/projectsApiService';
import { getErrors } from '../../../../../../helpers/helpers';
import Types from '../../../../../../../types/types';

import s from './StructureXPathes.module.scss';
const { initTabs } = Types;

const {
  setMaxData,
  setCheckedKeysXPathes,
  setParentCodeOptions,
  setExpandedKeys,
  setSearchXPathVal,
  setActiveBlockKeys,
  onFullScreen,
  setHasUnsavedChanges,
} = tablesSlice.actions;

export const StructureXPathes = () => {
  const { notification } = App.useApp();
  const dispatch = useAppDispatch();
  const [autoExpandParent, setAutoExpandParent] = useState(true);
  const [isReplace, setReplace] = useState(false);
  const [isShowModal, setIsShowModal] = useState(false);
  const [showUpdate, setShowUpdate] = useState('');
  // const [modal, contextHolder] = Modal.useModal();

  const {
    maxData,
    checkedKeysXPathes,
    expandedKeys,
    editableTable,
    searchXPathVal,
    activeXmlTab,
    cdaRedactorTabs,
    isFullScreen,
    hasUnsavedChanges,
  } = useAppSelector((state) => state.tablesSlice);
  const {
    data: attributeTypeOptions,
    // error: descriptionTargetShowcaseError,
    // isLoading: descriptionTargetShowcaseLoading,
  } = projectsApiService.useGetAttributeTypeOptionsQuery({ skip: 0, limit: 1000 });
  const [
    getProjectXPathStructure,
    {
      data: projectXPathStructureData,
      // isError: projectXPathStructureIsError,
      error: projectXPathStructureError,
      // status: projectXPathStructureStatus,
      isLoading: projectXPathStructureLoading,
    },
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
  ] = projectsApiService.useGetProjectXPathStructureMutation({ id: editableTable.id });
  const [
    getCheckAllXPath,
    {
      data: checkAllXPathData,
      // isError: projectXPathStructureIsError,
      error: checkAllXPathError,
      // status: projectXPathStructureStatus,
      isLoading: checkAllXPathLoading,
    },
  ] = projectsApiService.useCheckAllXPathMutation();
  const [uploadXlsx, { data: parseXlsxData, error: parseXlsxError, isLoading: parseXlsxLoading }] =
    projectsApiService.useParseXlsxDocMutation();
  const [getFileInfo, { data: fileInfoData, error: fileInfoError, isLoading: fileInfoLoading }] =
    projectsApiService.useGetXPathFileInfoMutation();
  const [getXPathFileXlsx] = projectsApiService.useGetXPathFileXlsxMutation();
  const handleSetHasChanges = () => {
    const hasChanges = { ...hasUnsavedChanges, [initTabs['CDA']]: true };
    const has = hasUnsavedChanges[initTabs['CDA']];
    if (!has) {
      dispatch(setHasUnsavedChanges(hasChanges));
    }
  };
  //Все обработчики ===============>
  const exportPropsReplace: UploadProps = {
    name: 'file',
    showUploadList: false,
    customRequest: (e) => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      if (!e.file.type.match('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')) {
        showNotification(notification, 'Неверный формат файла', '', 'error');
        return;
      }
      setReplace(true);
      const data = new FormData();
      data.append('file', e.file);
      uploadXlsx(data);
      setIsShowModal(!isShowModal);
    },
  };
  const exportPropsNoReplace: UploadProps = {
    name: 'file',
    showUploadList: false,
    customRequest: (e) => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      if (!e.file.type.match('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')) {
        showNotification(notification, 'Неверный формат файла', '', 'error');
        return;
      }
      setReplace(false);
      const data = new FormData();
      data.append('file', e.file);
      uploadXlsx(data);
      setIsShowModal(!isShowModal);
    },
  };
  const getFileInfoHandler = () => {
    const selectedMaxData = getCheckedKeysMaxData(maxData, checkedKeysXPathes);
    const savedData = getSavedMaxData(selectedMaxData);
    getFileInfo({ body: savedData, projectName: editableTable.project_name });
  };
  const onChooseAll = () => {
    const expKeys = [];
    if (!checkedKeysXPathes.length) {
      for (let i = 0; i < maxData.length; i++) {
        expKeys.push(maxData[i].key);
      }
    }

    dispatch(setCheckedKeysXPathes(expKeys));
  };
  const setCheckKeys = (expKeys) => {
    dispatch(setCheckedKeysXPathes(expKeys));
  };
  const onExpandAll = () => {
    const expKeys = !expandedKeys.length ? getAllKeys(maxData) || [] : [];

    dispatch(setActiveBlockKeys([]));
    dispatch(setExpandedKeys(expKeys));
  };
  const onSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    // const data = [...maxData];
    // const exp: string[] = value ? loopSearchLabel(data, value) : [];
    // dispatch(setExpandedKeys(exp as string[]));
    // // setSearchValue(value);
    dispatch(setSearchXPathVal(value));
    setAutoExpandParent(true);
  };
  const onExpand = (newExpandedKeys: string[]) => {
    dispatch(setExpandedKeys(newExpandedKeys));
    setAutoExpandParent(false);
  };
  const handleReload = () => {
    const currentTab =
      cdaRedactorTabs.find((tab) => tab.key === activeXmlTab) || cdaRedactorTabs[0];
    if (!currentTab.code && !currentTab.fileName) {
      showNotification(notification, notificationMessages.absentXml, ' ', 'error');
      return;
    }
    const dataCheckAllXPath = getDataForCheckXPath(maxData, currentTab.fileName);
    getCheckAllXPath(dataCheckAllXPath);
    setShowUpdate('');
  };
  const deleteXPath = () => {
    const data = [...maxData];
    checkedKeysXPathes.forEach((checkedKey) => {
      loopInfoData(data, checkedKey, (node, i, parent) => {
        parent.splice(i, 1);
      });
    });

    dispatch(setMaxData(data));
    dispatch(setCheckedKeysXPathes([]));
    handleSetHasChanges();
  };
  const onAddXPath = (id = '') => {
    const reFreezeMaxData = maxData ? [...maxData] : [];
    const { data: newData, newBlockKey } = getAddedMaxData(reFreezeMaxData, id);
    console.log('newBlockKey', newBlockKey);
    const parentCodeOptions = getParentDataOptions(newData);
    dispatch(setParentCodeOptions(parentCodeOptions));
    dispatch(setMaxData(newData));

    const lastCode = newData[newData.length - 1].title.key;
    dispatch(setActiveBlockKeys([lastCode]));
    handleSetHasChanges();
    const xpathWrapper = document.querySelector('[class *= VisualizationXPathes]');
    setTimeout(() => (xpathWrapper.scrollTop = xpathWrapper.scrollHeight), 500);
  };
  const fullScreen = () => {
    dispatch(onFullScreen(!isFullScreen));
  };
  const onShowModal = () => {
    setIsShowModal(!isShowModal);
    // modal.info(config);
  };
  //============================>
  const newData =
    useMemo(
      () => maxData && getMappedData([...maxData], searchXPathVal, attributeTypeOptions || []),
      [maxData, searchXPathVal, attributeTypeOptions],
    ) || [];

  const {
    parseXlsxError: parseXlsxErrorText,
    xPathStructureError,
    checkAllXPathErrorFormatted,
  } = getErrors({
    parseXlsxError,
    projectXPathStructureError,
    checkAllXPathError,
  });

  //Все useEffect ===============>
  useEffect(() => {
    if (searchXPathVal) {
      const data = [...maxData];
      const exp: string[] = searchXPathVal ? loopSearchLabel(data, searchXPathVal) : [];
      dispatch(setExpandedKeys(exp as string[]));
      setAutoExpandParent(true);
    } else {
      dispatch(setExpandedKeys([] as string[]));
      setAutoExpandParent(false);
    }
  }, [dispatch, searchXPathVal]);
  useEffect(() => {
    //success
    if (parseXlsxData && !parseXlsxError && !parseXlsxLoading) {
      if (!isReplace) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        // const preNormalData = getPreNormalData(parseXlsxData.data, isReplace, maxData) || [];
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const normalData = getNormalData(parseXlsxData.data) || [];
        const uniqueNewData = getUniqueData(maxData, normalData);
        dispatch(setMaxData([...maxData, ...uniqueNewData]));
      } else {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const normalData = getNormalData(parseXlsxData.data) || [];
        dispatch(setMaxData(normalData));
      }
    }
    //err
    if (parseXlsxError && !parseXlsxData && !parseXlsxLoading) {
      showNotification(
        notification,
        parseXlsxErrorText || ' ',
        notificationMessages.errUploadXml,
        'error',
      );
    }
  }, [parseXlsxData, parseXlsxError, parseXlsxLoading]);
  useEffect(() => {
    if (fileInfoData && !fileInfoError && !fileInfoLoading) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      getXPathFileXlsx({ filename: fileInfoData?.filename });
    }
  }, [fileInfoData, fileInfoError, fileInfoLoading]);
  useEffect(() => {
    if (checkAllXPathData && !checkAllXPathError && !checkAllXPathLoading) {
      const verificationXPathData = getVerificationXPathData(checkAllXPathData, maxData);
      dispatch(setMaxData(verificationXPathData));
    }

    if (!checkAllXPathData && checkAllXPathError && !checkAllXPathLoading) {
      showNotification(
        notification,
        notificationMessages.errRespXPathCheck,
        checkAllXPathErrorFormatted,
        'error',
      );
    }
  }, [checkAllXPathData, checkAllXPathError, checkAllXPathLoading]);
  useEffect(() => {
    if (editableTable.id) {
      getProjectXPathStructure({ id: editableTable.id });
    }
  }, [editableTable]);
  useEffect(() => {
    if (projectXPathStructureData && !projectXPathStructureLoading && !projectXPathStructureError) {
      const normalData = Array.isArray(projectXPathStructureData)
        ? getNormalData(projectXPathStructureData)
        : [];
      dispatch(setMaxData(normalData));
    }

    if (projectXPathStructureError) {
      showNotification(
        notification,
        notificationMessages.errRespXPathProject,
        xPathStructureError,
        'error',
      );
    }
  }, [projectXPathStructureData, projectXPathStructureLoading, projectXPathStructureError]);
  useEffect(() => {
    if (activeXmlTab) {
      setShowUpdate(activeXmlTab);
    }
  }, [activeXmlTab]);
  //============================>
  const currentTab = cdaRedactorTabs.find((tab) => tab.key === activeXmlTab) || cdaRedactorTabs[0];
  return (
    <div className={s.StructureXPathes} id={'StructureXPathes'}>
      <Spin
        tip='Loading...'
        spinning={projectXPathStructureLoading || parseXlsxLoading || checkAllXPathLoading}
        size='large'
      >
        <Modal
          open={isShowModal}
          title={'Выберете действие'}
          okText={'Отмена'}
          width={'max-content'}
          footer={''}
          onCancel={() => setIsShowModal(false)}
        >
          <div style={{ display: 'flex', padding: 0, gap: 8, justifyContent: 'center' }}>
            <Upload {...exportPropsReplace}>
              <Button>Заменить целиком</Button>
            </Upload>
            <Upload {...exportPropsNoReplace}>
              <Button>Добавить как новые строки</Button>
            </Upload>
          </div>
        </Modal>
        <div className={s.subHeader}>
          <Button onClick={fullScreen} icon={<FullscreenOutlined />}></Button>
        </div>
        <div className={s.header}>
          <Search className={s.searchField} value={searchXPathVal} onChange={onSearch} />

          <div className={s.exploreBtns}>
            <Button onClick={onShowModal} icon={<UploadOutlined />}>
              Импорт
            </Button>

            <Button onClick={getFileInfoHandler} icon={<DownloadOutlined />}>
              Экспорт
            </Button>
          </div>
        </div>
        <Divider style={{ margin: 0 }} />

        <div className={s.content} id={'StructureXPathes_content'}>
          <div className={s.contentControls}>
            <div className={s.leftBtns}>
              <Button onClick={onExpandAll} type={'text'}>
                {expandedKeys.length ? 'Скрыть все' : 'Раскрыть все'}
              </Button>
              <Button onClick={onChooseAll} type={'text'}>
                {checkedKeysXPathes.length ? 'Отменить выбор всех' : 'Выбрать все'}
              </Button>
            </div>

            <div className={s.rightBtns}>
              {checkedKeysXPathes?.length ? (
                <Popconfirm
                  title='Вы действительно хотите удалить выделенные xPath?'
                  onConfirm={deleteXPath}
                  onCancel={() => console.log('onCancel')}
                  okText='Да'
                  cancelText='Нет'
                >
                  <Button icon={<DeleteOutlined />}></Button>
                </Popconfirm>
              ) : (
                ''
              )}
              <Tooltip title={'Проверьте все xpath'}>
                <Button
                  type={currentTab?.fileName && showUpdate === activeXmlTab ? 'primary' : 'default'}
                  onClick={handleReload}
                  icon={<ReloadOutlined />}
                ></Button>
              </Tooltip>
              <Button onClick={() => onAddXPath()} icon={<PlusOutlined />}>
                Добавить xPath
              </Button>
            </div>
          </div>

          <VisualizationXPathes
            onExpand={onExpand}
            expandedKeys={expandedKeys}
            autoExpandParent={autoExpandParent}
            setCheckedKeys={setCheckKeys}
            checkedKeys={checkedKeysXPathes}
            gData={newData}
            loop={loop}
          />
        </div>
      </Spin>
    </div>
  );
};
